import React, { useState } from 'react'
import Button from 'Components/button'
import classNames from 'classnames'
import { secToMin } from 'lib/format-time'
import { sendTeaCommEvent } from 'lib/tea-analyze'
const play_icon = require('static/play-video.png')
const live_show_icon = require('static/brown-live-show.gif')
const default_article_icon = require('static/default-article.png')
interface ICardInfo {
  banner_type?: 'live' | 'article'
  title: string
  cover_url: string
  uid: number
  user_info: {
    username: string
    avatar: string
  }
  unique_id_str: string
  video_duration?: number
  comment_count?: number
  abstract_content: string
  series_id: number
}

export default function ArticleCard(article: ICardInfo) {
  const {
    banner_type,
    title,
    cover_url,
    user_info,
    unique_id_str: unique_id,
    video_duration = 0,
    comment_count,
    abstract_content,
    uid,
    series_id,
  } = article || {}
  const { username, avatar } = user_info || {}
  const [shouldShowAbstract, setShowAbstract] = useState(false)
  const titleRef = (node: HTMLParagraphElement) => {
    if (node === null) {
      return
    }
    const compStyles = window.getComputedStyle(node)
    const height = compStyles?.getPropertyValue('height')
    if (Number(height?.slice(0, height.length - 2)) <= 24) {
      setShowAbstract(true)
    } else {
      setShowAbstract(false)
    }
  }

  return (
    <a
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
      href={
        banner_type === 'live'
          ? `https://live.ixigua.com/room/${unique_id}/`
          : `/article/${unique_id}`
      }
      key={unique_id}
      className="article-card-link"
      onClick={() => {
        sendTeaCommEvent('click_series_module_group', {
          sub_tab: banner_type ? '文章' : '视频',
          group_id: unique_id,
          car_series_id: series_id,
        })
      }}
    >
      <div className="article-card">
        <div className="cover-wrapper">
          <div className="cover">
            <img src={cover_url || default_article_icon} />
          </div>
          {video_duration > 0 && (
            <span className="duration">
              <img src={play_icon} />
              <span>{secToMin(video_duration)}</span>
            </span>
          )}
        </div>
        <div className="detail">
          <p
            className={classNames(
              'title',
              banner_type === 'live' ? 'line-1' : 'line-2'
            )}
            ref={titleRef}
          >
            {title}
          </p>
          {banner_type === 'live' && (
            <Button className="enter-live-btn">
              <img src={live_show_icon} />
              点击进入直播间
            </Button>
          )}
          {banner_type !== 'live' && shouldShowAbstract && (
            <p className={classNames('abstract-content', 'line-1')}>
              {abstract_content}
            </p>
          )}
          <div className="author">
            <a
              href={`/user/ugc_profile/${uid}`}
              //  eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
              style={{
                width: '16px',
                height: '16px',
                marginRight: '8px',
                fontSize: '0',
              }}
            >
              <img src={avatar} />
            </a>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href={`/user/ugc_profile/${uid}`} target="_blank">
              <span className="author-name">{username}</span>
            </a>
            {comment_count !== undefined && (
              <span className="comment-count">{comment_count}人评论</span>
            )}
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .article-card-link:last-child .article-card {
            border-bottom: none;
          }
          .article-card {
            padding: 11px 0 16px;
            display: flex;
            align-items: flex-end;
            border-bottom: 1px solid #f2f4fa;
          }

          .article-card .cover-wrapper {
            margin-right: 10px;
            position: relative;
            width: 110px;
            height: 73px;
          }
          .article-card .cover {
            width: 100%;
            height: 100%;
            border-radius: 2px;
            overflow: hidden;
          }
          .cover img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
          }
          .article-card .duration {
            position: absolute;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 2px;
            right: 0;
            bottom: 0;
            width: 51px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .duration > img {
            margin-right: 2px;
            width: 12px;
            height: 12px;
            object-fit: cover;
            object-position: center;
          }
          .duration > span {
            transform: scale(0.833);
            transform-origin: left center;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #ffffff;
            letter-spacing: 0;
            line-height: 14px;
            font-weight: 400;
          }
          .article-card .detail {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 78px;
            width: 390px;
          }
          .article-card .title:hover,
          .article-card .abstract-content:hover {
            color: #e62021;
          }
          .article-card .title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #1f2129;
            letter-spacing: 0;
            line-height: 24px;
            font-weight: 500;
          }
          .article-card .abstract-content {
            opacity: 0.85;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #1f2129;
            letter-spacing: 0;
            line-height: 21px;
            font-weight: 400;
          }
          :global(.article-card .enter-live-btn) {
            border: 1px solid rgba(179, 125, 18, 0.4);
            border-radius: 2px;
            width: 116px;
            height: 24px;
            padding: 0 4px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #b37d12;
            letter-spacing: 0;
            font-weight: 400;
            display: flex;
            align-items: center;
          }
          :global(.article-card .enter-live-btn:hover) {
            color: #b37d12;
            border: 1px solid rgba(179, 125, 18, 0.4);
            background-color: rgba(179, 125, 18, 0.06);
          }
          :global(.article-card .enter-live-btn > img) {
            width: 16px;
            height: 16px;
            object-fit: cover;
            object-position: center;
            margin-right: 4px;
          }
          .article-card .author {
            display: flex;
            align-items: center;
          }
          .article-card .author:hover .author-name {
            color: #e62021;
          }
          .article-card .author img {
            width: 16px;
            height: 16px;
            object-fit: cover;
            object-position: center;
            border-radius: 50%;
            margin-right: 8px;
          }
          .article-card .author-name {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #979aa8;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 400;
          }
          .article-card .comment-count {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #979aa8;
            letter-spacing: 0;
            text-align: right;
            line-height: 18px;
            font-weight: 400;
            justify-self: flex-end;
            margin-left: auto;
          }
        `}
      </style>
    </a>
  )
}
